import { CURRENCY_CODE } from "@/lib/constant";
import {
  getFormattedProductItems,
  getProductNames,
  getProductSKUs,
} from "@repo/lib/helpers";
import { useFeatureFlag } from "@repo/lib/hooks/common";
import { useCallback } from "react";

const useTrackViewCart = () => {
  const isWebEngageEnabled = useFeatureFlag("webEngage");
  const trackViewCartEvent = useCallback(
    (cartInfo) => {
      if (!isWebEngageEnabled) {
        console.warn("WebEngage feature is disabled");
        return;
      }
      if (window.webengage) {
        if (cartInfo) {
          const { cartTotal, couponName, itemsQuantity, lineItems } = cartInfo;
          const eventData = {
            total: cartTotal.total,
            product_id: getProductSKUs(lineItems),
            product_names: getProductNames(lineItems),
            currency: CURRENCY_CODE,
            couponName: couponName || "",
            no_of_product: itemsQuantity,
            items: getFormattedProductItems(lineItems, couponName),
          };
          window.webengage.track("cart_viewed", eventData);
        }
      } else {
        console.error("WebEngage is not defined");
      }
    },
    [isWebEngageEnabled]
  );

  return { trackViewCartEvent };
};

export default useTrackViewCart;
